import { i18n } from './index';

const syncPreferredLanguage = (preferredLanguage) => {
  if (!preferredLanguage) return;
  void i18n.changeLanguage(preferredLanguage).catch(() => {
    // Non-blocking: language sync shouldn't interrupt auth flow.
  });
};

export default syncPreferredLanguage;
